import React from "react";
import { useState, useContext } from "react";
import { Card, Table, Collapse, Row, Col, Button } from "react-bootstrap";
import {
  CANCEL,
  ADD_PATIENT_DETAILS_STEP_4,
  LINK_PATIENT_MATCH,
  GIVEN_NAME,
  FAMILY_NAME,
  DOB,
  MOBILE_NUMBER,
  EMAIL,
  NEW_PATIENT,
  CREATE,
  NO_MATCH_MESSAGE,
  SELECTED_PARTICIPANT,
  COMPLETE_LINK,
  LINK,
  PARTICIPANT_LINK_FAIL,
} from "../../util/const";

import { Participant } from "../../types/participant";
import { Patient } from "../../types/patient";
import { DefaultPatient, PatientContext } from "../ActivePatients";
import PatientForm from "../PatientForm";
import InfoCards from "../../Components/InfoCards";
import { usePatientSearch } from "../../services/useData";
import { FormatDateForDisplay } from "../../util/data-utils";
import LinkingHelper from "../../Helpers/LinkingHelper";

export type MatchingProps = {
  participant: Participant;
  toggleDisplay: (didMatch: boolean) => void;
};

const PossibleMatches = (props: MatchingProps) => {

  const context = useContext(PatientContext);

  const participant = props.participant;
  const fetchedData = usePatientSearch({
    familyName: participant.familyName,
    givenNames: participant.givenName,
  });
  const searchResults = fetchedData.patients;

  const [error, setError] = useState("");
  const [open, setOpen] = useState(-1);
  const [isCreating, setIsCreating] = useState(false);


  const toggleCreating = (didSave: boolean) => {
    if(didSave)
      props.toggleDisplay(true);
    else
      setIsCreating(!isCreating);
  };

  const onCreateClick = (p: Participant) => {
    context.patient = DefaultPatient();
    context.patient.dueDate = p.dueDate;
    context.patient.currentGestation = p.weeksPregnant;
    context.patient.familyName = p.familyName;
    context.patient.givenNames = [p.givenName];
    context.patient.birthDate = p.birthDate;
    context.patient.email = p.email;
    context.patient.weight = p.prePregnancyWeight;
    context.patient.height = p.height;
    context.patient.documentId = p.documentId;

    toggleCreating(false);
  };

  const onCancelClick = () => 
  {
    setOpen(-1);
  }

  const onCompleteClick = (participant: Participant, item: Patient) =>
  {
    LinkingHelper(item, participant).then((value) => {
      if(value)
        props.toggleDisplay(true);
      else
        setError(PARTICIPANT_LINK_FAIL); 
    });   
  }

  if (isCreating) {
    return <PatientForm toggleDisplay={toggleCreating} title={ADD_PATIENT_DETAILS_STEP_4} isEditing={false}/>;
  }

  return (
    <Card className="mt-3 mb-3" border="secondary" text="white">
      <Card.Header className="fs-5 app-colour">
        <Row>
          <Col>{LINK_PATIENT_MATCH}</Col>
          <Col className="right">
            <Button
              type="button"
              onClick={(e) => {
                props.toggleDisplay(false);
              } }
              className="fs-6 btn-outline-white">
              {CANCEL}
            </Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="color-text fs-6">
        {SELECTED_PARTICIPANT}: {props.participant.givenName} {props.participant.familyName} | DOB: {FormatDateForDisplay(props.participant.birthDate)} | Email: {props.participant.email}
        <hr />
        {searchResults && searchResults.length > 0 ? (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>{GIVEN_NAME}</th>
                <th>{FAMILY_NAME}</th>
                <th className="text-center">{DOB}</th>
                <th>{MOBILE_NUMBER}</th>
                <th>{EMAIL}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
            {searchResults.map((item: Patient, i: number) => {
              return (
                <React.Fragment key={i}>
                <tr className="middle">
                  <td>{item.givenNames}</td>
                  <td>{item.familyName}</td>
                  <td className="text-center">{FormatDateForDisplay(item.birthDate)}</td>
                  <td>{item.phone}</td>
                  <td>{item.email}</td>
                  <td className="text-center">
                    <Button
                        className="btn-color"
                        disabled = {open > -1}
                        onClick={() => {
                          setOpen(i);
                        }}
                        aria-controls="example-collapse-text">
                        {LINK}
                      </Button>
                  </td>
                </tr>
                <tr>
                  <Collapse in={open === i}>
                    <td colSpan={6} id="example-collapse-text">
                      <InfoCards participant={props.participant} patient={item}></InfoCards>
                      <div className="text-center mt-3 mb-3"><Button className="btn-color me-2" onClick={() => onCancelClick()}>{CANCEL}</Button>
                      <Button className="btn-color me-2" onClick={() => onCompleteClick(props.participant, item) }>
                        {COMPLETE_LINK}
                      </Button>
                      </div>
                    </td>
                  </Collapse>
                </tr>
                </React.Fragment>
              );  
            })}
            </tbody>
          </Table>
        ) : (
          <Col className="centre">
            <div>{NO_MATCH_MESSAGE}</div>
            <Button className="btn-color mt-2" onClick={() => onCreateClick(props.participant)}>
              {CREATE} {NEW_PATIENT}
            </Button>
          </Col>
        )}
      </Card.Body>
    </Card>
  );
};

export default PossibleMatches;